import Svg, {
  Path,
  type PathProps,
  Rect,
  type SvgProps,
  Text,
} from 'react-native-svg'

import {usePalette} from '#/lib/hooks/usePalette'

const ratio = 17 / 64

export function Logotype({
  fill,
  textX = '20.000',
  ...rest
}: {fill?: PathProps['fill']; textX?: string} & SvgProps) {
  const pal = usePalette('default')
  // @ts-ignore it's fiiiiine
  const size = parseInt(rest.width || 32)

  return (
    <Svg
      fill="none"
      viewBox="0 0 750 180"
      {...rest}
      width={size}
      height={Number(size) * ratio}>
      <Rect width="100%" height="100%" fill="transparent" />
      <Text
        x={textX}
        y="156.772"
        fill={fill || pal.text.color}
        fontSize="180px"
        fontWeight="700"
        fontFamily="Inter, ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, Arial, 'DejaVu Sans', sans-serif">
        W Social
      </Text>
    </Svg>
  )
}
